import { useEffect, useRef } from 'react'
import './Loader.css'

export const RippleLoader = () => {
    return (
        <div className="lds-ripple"><div></div><div></div></div>
    )
}

export const EllipsisLoader = () => (
    <div className="lds-ellipsis"><div /><div /><div /><div /></div>
)

export const WhiteboxLoader = () => (
    <div className="whitebox-loader">
        <div className="center">
            <EllipsisLoader />
        </div>
    </div>
)

export const SuccessMark = () => {
   

        return (
            <div className="success-holder">
                <div className="success-checkmark">
                    <div className="check-icon">
                        <span className="icon-line line-tip"></span>
                        <span className="icon-line line-long"></span>
                        <div className="icon-circle"></div>
                        <div className="icon-fix"></div>
                    </div>
                </div>
            </div>
        )
   
}
export const MySuccessMark = ({succeed,setSucceed}:{succeed:boolean,setSucceed:Function}) => {
    let time=useRef<any>(null)
    useEffect(()=>{
     
        if (succeed){
           time.current=setTimeout(()=>{setSucceed(false)},4000)
        }
        return ()=>{
            if (time.current) {
                clearTimeout(time.current)
            }
        }
    },[succeed])
    if (succeed){

        return (
            <div className="success-holder">
                <div className="success-checkmark">
                    <div className="check-icon">
                        <span className="icon-line line-tip"></span>
                        <span className="icon-line line-long"></span>
                        <div className="icon-circle"></div>
                        <div className="icon-fix"></div>
                    </div>
                </div>
            </div>
        )
    }
    return null
}
export const ErrorMark =({failed,setFailed}:{failed:boolean,setFailed:Function})=>{
    let time=useRef<any>(null)
    useEffect(()=>{
     
        if (failed){
           time.current=setTimeout(()=>{setFailed(false)},4000)
        }
        return ()=>{
            if (time.current) {
                clearTimeout(time.current)
            }
        }
    },[failed])
    if (failed) {

        return (
            <div className="ErrorMark">
    
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" className='errorMark'>
                <circle className="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                <line className="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
                <line className="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
                </svg>
            </div>
        )
    }
    return null
}
export const ColorfullLoader = () => {
    return (
        <>
            <div className="cssload-dots">
                <div className="cssload-dot"></div>
                <div className="cssload-dot"></div>
                <div className="cssload-dot"></div>
                <div className="cssload-dot"></div>
                <div className="cssload-dot"></div>
            </div>

            <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <filter id="goo">
                        <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="6" ></feGaussianBlur>
                        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0	0 1 0 0 0	0 0 1 0 0	0 0 0 18 -7" result="goo" ></feColorMatrix>
                    </filter>
                </defs>
            </svg>
        </>
    )
}